<template>
  <div class="access-rapid">
    <div class="row mt-4">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <h2
          class="text-left title-access-rapid mb-3"
          v-html="$sanitize.sanitizeI18nContent($t('access_rapid.title'))"
        ></h2>
      </div>

      <div class="col-lg-8 offset-lg-1">
        <div class="d-flex gap-4 rapid-block-inner">
          <div
            v-for="shortcut in displayedShortcuts"
            :key="shortcut.id"
            class="card cursor-pointer"
            @click="navigateToShortcut(shortcut)"
          >
            <img :src="getShortcutIcon(shortcut.icon)" width="60" height="60" />
            <h4 class="text-center">{{ shortcut.label }}</h4>
          </div>
          <div class="card card-racc cursor-pointer" @click.prevent="OpenDrawer">
            <img :src="add_raccourci" width="60" height="60" />
            <h4 class="text-center" v-html="$sanitize.sanitizeI18nContent($t('access_rapid.add_shortcut'))"></h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mas_factures from "../assets/mes_factures-blue.svg";
  import mes_commandes from "../assets/mes_commandes-blue.svg";
  import mes_stats from "../assets/mes_stats-blue.svg";
  import add_raccourci from "../assets/add.svg";
  import contact from "../assets/contact-blue.svg";
  import documents from "../assets/documents-blue.svg";
  import adresse from "../assets/adresse-livraison-blue.svg";
  import calucl_ration from "../assets/calucl-ration-blue.svg";
  import { useShortcutsStore } from "@/stores/shortcutsStore";

  export default {
    name: "access-rapidList",
    data() {
      return {
        mas_factures,
        mes_commandes,
        mes_stats,
        add_raccourci,
        contact,
        documents,
        adresse,
        calucl_ration,
        shortcutsStore: null,
      };
    },
    computed: {
      displayedShortcuts() {
        if (!this.shortcutsStore) return [];
        return this.shortcutsStore.selectedShortcutsWithConfig;
      },
    },
    created() {
      this.shortcutsStore = useShortcutsStore();
    },
    methods: {
      OpenDrawer() {
        this.$emit("open-drawer-raccourci"); // Émission de l'événement
      },
      getShortcutIcon(iconName) {
        const iconMap = {
          "mes_factures.svg": this.mas_factures,
          "mes_commandes.svg": this.mes_commandes,
          "mes_stats.svg": this.mes_stats,
          "contact.svg": this.contact,
          "documents.svg": this.documents,
          "adresse-livraison.svg": this.adresse,
          "calucl-ration.svg": this.calucl_ration,
        };
        return iconMap[iconName] || this.mas_factures;
      },
      navigateToShortcut(shortcut) {
        this.$router.push({
          name: "my-account",
          query: { tab: shortcut.tab },
        });
      },
    },
  };
</script>

<style scoped>
  .access-rapid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 30px;
    margin-bottom: 30px;
    justify-content: center;
  }
  .title-access-rapid {
    color: #1e347d;
    font-weight: 900;
    line-height: 55px;
    font-size: 45px;
    font-style: normal;
  }
  .access-rapid .card {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
    position: relative;
    background: #f5f6f9;
    border: 1px solid #e1e4ed;
    border-radius: 10px;
    img {
      position: relative;
      left: 35%;
      top: -25%;
    }
    label {
      position: relative;
      top: -6%;
    }
  }
  .card-racc {
    background: #e1e4ed !important;
    img {
      cursor: pointer;
    }
    label {
      position: relative;
      top: -18% !important;
      cursor: pointer;
    }
  }
  @media (max-width: 768px) {
    .title-access-rapid {
      font-size: 24px;
      line-height: 32px;
      text-align: center;
      padding: 0 16px;
      margin-bottom: 20px !important;
    }
    .access-rapid {
      margin-top: 16px;
      margin-bottom: 16px;
      gap: 10px;
      padding: 0 16px;
    }
    .rapid-block-inner {
      flex-direction: column !important;
      gap: 12px !important;
      align-items: center !important;
    }
    .access-rapid .card,
    .card-racc {
      width: 90%;
      max-width: 400px;
      margin: 0 auto 8px;
      font-size: 16px;
      padding: 16px 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .access-rapid .card img,
    .card-racc img {
      left: 0 !important;
      top: 0 !important;
      width: 48px !important;
      height: 48px !important;
      margin-bottom: 8px;
      position: static !important;
      transform: none !important;
    }
    .access-rapid .card h4,
    .card-racc h4 {
      font-size: 14px !important;
      margin-top: 4px;
      margin-bottom: 0;
      text-align: center;
      top: 0 !important;
    }
  }
</style>
